export default __webpack_public_path__ + "static/media/new-twi-dark.860cfa92.svg";